import React, { useEffect, useState } from 'react';
import useBetslip from './useBetslip';
import { getAnimationDuration, getBetDescription, getConfiguration, getToolTipDesc, parseHandicap, showMatchDesc } from '../data/utils';
import Img from './Img';
import { ASIAN_HANDICAP, HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP } from '../data/constants';

export function useHighlightOddChange(value, enabled) {
    const [savedValue, setSavedValue] = useState(value);
    const [className, setClassName] = useState('');

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let newClassName = '';
        if (value == null) {
			newClassName = '';
		} else if (savedValue != null && savedValue !== value) {
			if (value > savedValue) {
				newClassName =  ' increased';
			} else {
				newClassName = ' decreased';
			}
		}

        setSavedValue(value);
        let t = null;
        if (newClassName !== className) {
            setClassName(newClassName);
            const timeout = getAnimationDuration();
            t = setTimeout(() => setClassName(''), timeout);
        }

        return () => t && clearTimeout(t);
    }, [value, enabled]);

    return className;
}

export function getOddDesc(odd, noHandicap = false) {
    let desc = odd.desc;
    
    const betData = odd.betData;
    if (betData.hideHandicap) {
        desc = `${getBetDescription(betData, true)} ${odd.desc}`;
    } else if (showMatchDesc(odd)) {
        desc = getToolTipDesc(odd);
    } else {
        const conf = getConfiguration();
        if (!betData.calculateHandicapDescription || betData.handicap === 0 || HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP.includes(betData.tipoHandicap) || (conf.nas && ASIAN_HANDICAP.includes(betData.id))) {
            desc = odd.desc;
        }
    }

    if (!noHandicap) {
        if (odd.desc?.trim()?.length > 0) {
            const suffix = parseHandicap('', betData.handicap, betData.tipoHandicap, betData.eqs, betData.dia);
            if (suffix.length > 0 && suffix !== '0') {
                desc = `${odd.desc} (${suffix})`;
            }
        }
    }

    return desc;
}

export default function Odd(props) {
    const odd = props.data;
    const [addBet, selected] = useBetslip(odd);
    const className = useHighlightOddChange(odd.value, odd.matchData.isLive);

    const desc = props.desc || getOddDesc(odd, props.noHandicap);
    let classList = '';
    if (selected) {
        classList = ' active';
    } else if (odd.value == null) {
        classList = ' disabled';
    }

    return (
        <div className={"c_11" + classList + className} onClick={addBet} data-type={props.type} data-agg-id={odd.betData.aggId} data-bet-id={odd.betData.id} data-odd-id={odd.id}>
            {props.showDesc &&
                <span className="c_11_1">{desc}</span>
            }
            {odd.value == null ?
                <Img className="c_11_2" src="icon_caution_my_account.svg" height="16px" width="16px" />
                :
                <span className="c_11_1">{odd.value}</span>
            }
        </div>
    );
}
